//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('departmentMenu', {
//        templateUrl: 'views/components/views/departmentMenu/departmentMenu.template.html?v=' + module.version, 
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'departmentMenuService', function ($stateParams, stateService, modalService, translateService, departmentMenuService) {
//            const vm = this;
//            let departmentId = $stateParams.department_id;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                departmentButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('departmentlang', { department_id: vm.model.menu.department_id }) }
//                ],
//                menu: {},
//                lockedDelete: false
//            };

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            async function loadMenu() {
//                vm.model.menu = (await departmentMenuService.getDepartmentMenu({ department_id: departmentId }))[0];
//            }

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    departmentMenuService.deleteObj(vm.model.menu).then((response) => {
//                        if (response[0] && response[0].errorcode !== '0') {
//                        	modalService.show({
//                        		type: 'warning',
//                        		title: translations.error,
//                        		message: response[0].errormessage,
//                        		buttons: [{
//                        			label: translations.ok,
//                        			cssClass: 'btn-warning',
//                        			action: (dialogItself) => {
//                        				dialogItself.close();
//                        				vm.model.lockedDelete = false;
//                        			}
//                        		}]
//                        	});
//                        } else {
//                        	vm.model.lockedDelete = false;
//                        	stateService.back();
//                        }
//                    }, () => {
//                        vm.model.lockedDelete = false;
//                    });
//                }, () => {
//                    vm.model.lockedDelete = false;
//                });
//            };

//            vm.$onInit = function () {
//                translate();
//                loadMenu();
//            };
//        }]
//    });
//})();
